<mat-sidenav-container class="sidenav-container" [class.nested]="nested" [style.height]="'100%'">
  <mat-sidenav
    [class]="sidenavClass"
    class="sidenav"
    [style.border-color]="primaryColor"
    fixedInViewport
    [fixedBottomGap]="0"
    [fixedTopGap]="fixedTopGap"
    [attr.role]="role$ | async"
    [mode]="mode$ | async"
    [opened]="opened$ | async">
    @if (isMainNav) {
      <mat-toolbar [style.background-color]="primaryColor" [style.color]="secondaryColor">
        <button
          mat-icon-button
          id="menu-button"
          (click)="sidenav.toggle()"
          [attr.aria-label]="sidenav?.opened ? 'Collapse menu' : 'Expand menu'">
          <mat-icon>menu</mat-icon>
        </button>
        <a
          class="brand-logo"
          [style.background-image]="logoUri"
          mat-list-item
          id="brand-logo-mobile"
          title="Konexus"
          routerLink="/"></a>
      </mat-toolbar>
    }
    @if (!!sideNavTitle && nested) {
      <ng-container *ngTemplateOutlet="nestedToolbar"></ng-container>
    }
    <ng-content select="[pre-sidenav]"></ng-content>
    @if (navigationElements?.length) {
      <mat-nav-list [class.nested-nav-list]="nested">
        @for (element of navigationElements; track $index) {
          <app-nav-element [nested]="true" [element]="element" [level]="1"></app-nav-element>
        }
        @if (withBottomPadding) {
          <p class="mat-list-item-header">&nbsp;</p>
        }
      </mat-nav-list>
    }
    <ng-content select="[post-sidenav]"></ng-content>
  </mat-sidenav>
  <mat-sidenav-content>
    <ng-content selector="toolbar"></ng-content>
    @if (nested && !sidenav?.opened) {
      <ng-container *ngTemplateOutlet="nestedToolbar"></ng-container>
    }
    <ng-content selector="content"></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>

<ng-template #nestedToolbar>
  <mat-toolbar class="nested-toolbar">
    <div class="sidenav-title">
      @if (!sidenav?.opened) {
        <button
          mat-icon-button
          (click)="sidenav.toggle()"
          [attr.aria-label]="'Expand ' + (sideNavTitle | translate: locale.language) + ' menu'">
          <mat-icon>menu_open</mat-icon>
        </button>
      }
      <span>{{ sideNavTitle | translate: locale.language }}</span>
    </div>
    @if (!sidenav?.opened && withMiniNav) {
      <div class="mini-nav">
        <button mat-button [matMenuTriggerFor]="navMenu" class="mini-nav-current">
          {{ currentPage | translate: locale.language }}
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
      </div>
      <mat-menu #navMenu="matMenu">
        @for (el of navigationElements; track el.name) {
          <a mat-menu-item [routerLink]="el.route">
            {{ el.name | translate: locale.language }}
          </a>
        }
      </mat-menu>
    }
    <span class="toolbar-spacer"></span>
    @if (sidenav?.opened) {
      <button
        mat-icon-button
        (click)="sidenav.toggle()"
        [attr.aria-label]="'Collapse ' + (sideNavTitle | translate: locale.language) + ' menu'">
        <mat-icon>chevron_left</mat-icon>
      </button>
    }
  </mat-toolbar>
</ng-template>
